var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-message"},[_c('van-cell-group',{staticClass:"van-hairline--top van-hairline--bottom",attrs:{"title":"基本信息","border":""}},_vm._l((_vm.content),function(item,index){return _c('van-cell',{key:index,attrs:{"title":item.label,"value":item.value}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }